import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "est_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const authHeaders = () => {
  const t = getToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
};

// Public
export const createLead = (payload) => axios.post(`${API}/leads`, payload);

// Auth
export const login = (email, password) =>
  axios.post(`${API}/auth/login`, { email, password });
export const fetchMe = () => axios.get(`${API}/auth/me`, { headers: authHeaders() });

// Protected
export const fetchLeads = () => axios.get(`${API}/leads`, { headers: authHeaders() });
export const updateLeadStatus = (id, status) =>
  axios.patch(`${API}/leads/${id}?status=${status}`, {}, { headers: authHeaders() });
